import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { forwardRef as b, useRef as $, useState as k, useCallback as g, useEffect as E, useImperativeHandle as F } from "react";
import n from "./styles.module.less.js";
import L from "./generic-file.svg.js";
import w from "./cross-circle.svg.js";
import R from "./icon/loader.png.js";
const T = b(
  (t, u) => {
    var f;
    const { value: l = [], onChange: s, disabled: a, getTranslation: p } = t, d = $(null), [v, o] = k(!1), h = g(() => {
      a || o(!0);
    }, [a]), I = g(() => {
      a || o(!1);
    }, [a]), N = (e) => {
      e.target.files && !a && s([...l || [], ...Array.from(e.target.files)]);
    }, C = (e) => {
      e.preventDefault(), e.dataTransfer.files && !a && s([...l || [], ...Array.from(e.dataTransfer.files)]), o(!1);
    }, c = (e) => {
      var i;
      e.preventDefault(), a || (i = d.current) == null || i.click();
    }, D = (e) => {
      a || s((l || []).filter((i, y) => y !== e));
    };
    return E(() => {
      var e;
      return (e = document.getElementById("browse-file")) == null || e.addEventListener("click", c), () => {
        var i;
        (i = document.getElementById("browse-file")) == null || i.removeEventListener("click", c);
      };
    }, []), F(u, () => ({
      click: c
    })), /* @__PURE__ */ m(
      "div",
      {
        ...t.props,
        className: `${n.fileInput} ${v ? n.dragging : ""} ${((f = t.props) == null ? void 0 : f.className) || ""}`,
        onDrop: C,
        onDragOver: (e) => e.preventDefault(),
        onDragEnter: h,
        onDragLeave: I,
        children: [
          /* @__PURE__ */ r(
            "div",
            {
              className: n.fileInputLabel,
              dangerouslySetInnerHTML: { __html: p("chat.browse-or-drop") }
            }
          ),
          /* @__PURE__ */ r("input", { ref: d, type: "file", onChange: N }),
          l.length > 0 ? /* @__PURE__ */ r("div", { className: n.fileList, children: /* @__PURE__ */ r("div", { className: n.fileChips, children: l.map((e, i) => /* @__PURE__ */ m(
            "div",
            {
              className: `${n.fileChip} ${!(e instanceof File) && e.id ? n.uploaded : ""}`,
              children: [
                /* @__PURE__ */ r(
                  "div",
                  {
                    className: `${n.uploading} ${e.uploading ? n.active : ""}`,
                    children: /* @__PURE__ */ r("img", { src: R, alt: "loading" })
                  }
                ),
                /* @__PURE__ */ r("div", { className: n.fileIcon, children: /* @__PURE__ */ r(L, {}) }),
                e.name || "file",
                "id" in e && !e.attachedToMessage || !("id" in e) ? /* @__PURE__ */ r(
                  "div",
                  {
                    className: n.fileRemoveIcon,
                    onClick: () => D(i),
                    title: "Remove file",
                    children: /* @__PURE__ */ r(w, {})
                  }
                ) : null
              ]
            },
            i
          )) }) }) : null
        ]
      }
    );
  }
);
T.displayName = "FileInput";
export {
  T as FileInput
};
